// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.court-system-forbidden{
  display:flex;
  justify-content:center;
  width:100%;
  height:100%;
  padding:1rem;
  margin-top:1rem;
  background-color:#fff;
  border-radius:0.25rem;
}

  .court-system-forbidden__container{
    align-self:center;
    text-align:center;
  }

  .court-system-forbidden__container a{
      -webkit-text-decoration:none;
      text-decoration:none;
    }

  .court-system-forbidden__container a:hover{
        -webkit-text-decoration:underline;
        text-decoration:underline;
      }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
